<template>
  <CModal :visible="this.visible" @close="$emit('hide-save-confirm')">
    <CModalHeader>
      <CModalTitle>Login Help</CModalTitle>
    </CModalHeader>
    <CModalBody>
      <CRow>
        <CCol>
          <p>
            If you are having trouble with the logging in please contact your store administrator.
            <br />
            If you do not know who your store admin is, please contact Unipharm customer service at
            {{ UNIPHARM_CUSTOMER_SERVICE_NUMBER }} or
            <a :href="'mailto:' + UNIPHARM_CUSTOMER_SERVICE_EMAIL"> {{ UNIPHARM_CUSTOMER_SERVICE_EMAIL }} </a>
          </p>
        </CCol>
      </CRow>
    </CModalBody>
    <CModalFooter>
      <CButton @click="$emit('hide-save-confirm')" color="primary" size="sm"> Okay </CButton>
    </CModalFooter>
  </CModal>
</template>

<script>
/**
 * Modal to edit current drawer settings
 * @author Scott Gingerysty (Fresche Solutions)
 * @date April 2023
 */

export default {
  name: 'ModalLoginHelp',
  data() {
    return {
      UNIPHARM_CUSTOMER_SERVICE_NUMBER: process.env.VUE_APP_UNIPHARM_CUSTOMER_SERVICE_NUMBER,
      UNIPHARM_CUSTOMER_SERVICE_EMAIL: process.env.VUE_APP_UNIPHARM_CUSTOMER_SERVICE_EMAIL,
    };
  },
  props: {
    visible: false,
  },
  methods: {},
  components: {},
};
</script>
<style scoped></style>
